import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import "./CustomCursor.css";

const CustomCursor = () => {
    const cursorRef = useRef(null);
    const cursorDotRef = useRef(null);

    useEffect(() => {
        const moveCursor = (e) => {
            const { clientX: x, clientY: y } = e;
            gsap.to(cursorRef.current, {
                x,
                y,
                duration: 0.2,
                ease: "power3.out",
                boxShadow: `0px 0px 15px #57bfe4`,
            });

            gsap.to(cursorDotRef.current, {
                x,
                y,
                duration: 0.1,
                ease: "power2.out",
            });
        };
    
        const hideCursor = () => {
            gsap.to([cursorRef.current, cursorDotRef.current], {
                opacity: 0,
                duration: 0.2,
            });
        };
    
        const showCursor = () => {
            gsap.to([cursorRef.current, cursorDotRef.current], {
                opacity: 1,
                duration: 0.2,
            });
        };
    
        window.addEventListener("mousemove", moveCursor);
        document.addEventListener("mouseleave", hideCursor);
        document.addEventListener("mouseenter", showCursor);
        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "hidden") hideCursor();
            else showCursor();
        });
    
        return () => {
            window.removeEventListener("mousemove", moveCursor);
            document.removeEventListener("mouseleave", hideCursor);
            document.removeEventListener("mouseenter", showCursor);
            document.removeEventListener("visibilitychange", hideCursor);
        };
    }, []); 

    return (
        <>
            <div className="custom-cursor" ref={cursorRef}></div>
            <div className="cursor-dot" ref={cursorDotRef}></div>
        </>
    );
};

export default CustomCursor;
